import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'toLocalDateTime',
    standalone: false
})

export class UTCtoLocalDatePipe implements PipeTransform {
    constructor(private readonly datePipe: DatePipe) {}
    transform(value: string, ...args: any[]) {
        return this.datePipe.transform(value, 'MM/dd/yyyy, HH:mm:ss zzzz');
    }
}